export default __webpack_public_path__ + "/dist/images/1089230.png";